//
// Utility Plugin for setting the configuration
//
import { pluginFactory } from './utils/plugins';
export var BVConfigPlugin = /*#__PURE__*/pluginFactory();


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/bv-config.js
// module id = 774
// module chunks = 0